import MessagingBase from './messaging-base';

export default class MessagingUser extends MessagingBase {
  // Users have a non-standard creation flow as they are created in bulk
  // via our /batch-create endpoint. This override exists to allow ember-data
  // to update our unsaved records with the response from that endpoint.
  createRecord(store, type, snapshot) {
    const { data } = snapshot.adapterOptions;
    return new Promise((resolve, reject) => {
      if (data) {
        resolve({ data });
      } else {
        reject(new Error('User creation requires data in adapterOptions'));
      }
    });
  }
}
